import { Component, Input, OnChanges } from '@angular/core';
import { DASHBOARD_TEMPLATES } from '../dashboard-templates';
import { AuthenticationService } from 'authentication';

@Component({
  selector: 'app-fb-dashboard',
  templateUrl: './fb-dashboard.component.html',
  styleUrls: ['./fb-dashboard.component.scss']
})
export class FbDashboardComponent implements OnChanges {
  @Input() dashboardTemplate: string;
  isFbHrManager: boolean;
  dashboardJson: any;
  // private titleToRedirectPageFormId = {
  //   "Leave Approvals": 91,
  //   // "Employee Status": 26,
  //   "Onboarding Summary": 83,
  //   "Employee Exit Summary": 38,
  //   "Holiday List": 60,
  //   "Employee Leave Status": 104,
  //   "Leave balance": 103
  //   // Add other titles and their IDs as needed
  //   // "Team Members"
  // };
  @Input() titleToRedirectPageFormId = {};
  @Input() notificationRedirectPageFormId = {};
  userFN: string;
  userLN: string;

  constructor(
    private authenticationService: AuthenticationService
  ) { }

  ngOnChanges(): void {
    if (!this.dashboardTemplate) return;
    this.loadDashboardTemplate();
    this.isFbHrManager = !!this.authenticationService.currentUserValue && this.authenticationService.currentUserValue['permissions'].includes('FORMS_BUILDER_HR_MANAGER');
  }

  loadDashboardTemplate(){
    const template = DASHBOARD_TEMPLATES[this.dashboardTemplate];

    if (this.dashboardTemplate !== 'employee') {
      this.setDashboardJson(template);
      return;
    }

    this.authenticationService.currentUser.subscribe(data => {
      if (data) {
        this.userFN = data?.firstname || null;
        this.userLN = data?.lastName || null;
        const welcomeMessage = this.getWelcomeMessage();
        this.dashboardJson = {
          ...template,
          title: `Welcome${welcomeMessage}!`,
          layoutData: this.addRedirectPageFormIds([...template.layoutData])
        };
      } else {
        this.setDashboardJson(template);
      }
    });
  }
  

  private getWelcomeMessage(): string {
    if (!this.userFN) return '';
    if (this.userLN) return ` ${this.userFN} ${this.userLN}`;
    return ` ${this.userFN}`;
  }

  private setDashboardJson(template: any): void {
    this.dashboardJson = {
      ...template,
      layoutData: this.addRedirectPageFormIds([...template.layoutData])
    };
  }

  handleTeamMembersCountChange(count: number) {
    //const template = { ...DASHBOARD_TEMPLATES['employee'] };
    const template = DASHBOARD_TEMPLATES[this.dashboardTemplate];
    template.layoutData.forEach((row: any) => {
      row.children.forEach((column: any) => {
        if (column.content && column.content.type === "team_members_tile") {
          column.content.title = `My Team(${count})`; 
        }
      });
    });
    //this.setDashboardJson(template); 
    this.loadDashboardTemplate();
  }
  
  private addRedirectPageFormIds(layoutData: any[]): any[] {
    return layoutData.map(item => {
      const content = item.content;
      if (content) {
        if (content.type && content.type === 'notification_tile' && this.notificationRedirectPageFormId) {
          content.notificationRedirection = JSON.parse(JSON.stringify(this.notificationRedirectPageFormId));
        }
        if (content.title && this.titleToRedirectPageFormId && this.titleToRedirectPageFormId[content.title]) {
          content.dashboardRedirectPageFormId = this.titleToRedirectPageFormId[content.title];
        }
      }
      if (item.children) {
        item.children = this.addRedirectPageFormIds(item.children);
      }
      return item;
    });
  }

}
